export const QUERY_DEFAULT_VALUES = {
  PageLimit: 5,
  pageOffset: 0,
};
